export default "__VITE_ASSET__30518eaf__"